module.exports = __webpack_public_path__ + "img/qrcode-dingtalk.039a36ac.png";